import { Ionicons } from '@expo/vector-icons'
import React from 'react'
import {
  Linking,
  Modal,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native'

interface ForceUpdateModalProps {
  visible: boolean
  currentVersion?: string
  minVersion: string
}

const ForceUpdateModal: React.FC<ForceUpdateModalProps> = ({
  visible,
  currentVersion,
  minVersion,
}) => {
  const handleUpdatePress = () => {
    // Open app store based on platform
    const storeUrl = Platform.select({
      ios: 'https://apps.apple.com/app/id6504290489',
      android:
        'https://play.google.com/store/apps/details?id=com.rescuebase.app',
      default: 'https://rescuebase.com',
    })

    if (storeUrl) {
      Linking.openURL(storeUrl)
    }
  }

  return (
    <Modal
      animationType="fade"
      presentationStyle="fullScreen"
      transparent={false}
      visible={visible}
    >
      <View style={styles.container}>
        <View style={styles.content}>
          <View style={styles.iconContainer}>
            <Ionicons color="#007AFF" name="cloud-download-outline" size={80} />
          </View>

          <Text style={styles.title}>Update Required</Text>

          <Text style={styles.message}>
            A new version of Rescuebase is available and required to continue
            using the app.
          </Text>

          <View style={styles.versionInfo}>
            <Text style={styles.versionText}>
              Current Version: {currentVersion}
            </Text>
            <Text style={styles.versionText}>
              Required Version: {minVersion}
            </Text>
          </View>

          <TouchableOpacity
            accessibilityRole="button"
            onPress={handleUpdatePress}
            style={styles.updateButton}
          >
            <Text style={styles.updateButtonText}>Update Now</Text>
          </TouchableOpacity>

          <Text style={styles.footerText}>
            Please update to the latest version to continue using Rescuebase.
          </Text>
        </View>
      </View>
    </Modal>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 32,
  },
  content: {
    alignItems: 'center',
    maxWidth: 400,
    width: '100%',
  },
  iconContainer: {
    marginBottom: 32,
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#1A1A1A',
    marginBottom: 16,
    textAlign: 'center',
  },
  message: {
    fontSize: 16,
    color: '#666666',
    textAlign: 'center',
    lineHeight: 24,
    marginBottom: 32,
  },
  versionInfo: {
    backgroundColor: '#F5F5F5',
    borderRadius: 12,
    padding: 16,
    marginBottom: 32,
    width: '100%',
  },
  versionText: {
    fontSize: 14,
    color: '#333333',
    marginBottom: 4,
    textAlign: 'center',
  },
  updateButton: {
    backgroundColor: '#007AFF',
    borderRadius: 12,
    paddingVertical: 16,
    paddingHorizontal: 32,
    marginBottom: 24,
    width: '100%',
    alignItems: 'center',
  },
  updateButtonText: {
    color: '#FFFFFF',
    fontSize: 18,
    fontWeight: '600',
  },
  footerText: {
    fontSize: 14,
    color: '#999999',
    textAlign: 'center',
    lineHeight: 20,
  },
})

export default ForceUpdateModal
